import ReviewEligibilityCriteria from './ReviewEligibilityCriteria';

export default ReviewEligibilityCriteria;
